/**
 * @fileoverview Barrel export for prose-comparer-committee-v2 composite agent.
 */

export { definition } from './definition';
export { flow, proseComparerCommitteeV2AgentFlow } from './flow';
export { InputSchema, OutputSchema, CommitteeVoteSchema } from './schema';
export type { Input, Output, CommitteeVote } from './schema';
